/** @format */

const strokeWidth = 1 / 72;

export const bleedlineStyle = {
    fill: 'none',
    stroke: '#000000',
    strokeWidth
};

export const knockoutStyle = {
    fill: 'none',
    stroke: '#00adef',
    strokeWidth
};

export const dielineStyle = {
    fill: 'none',
    stroke: '#DF3D32',
    strokeWidth: strokeWidth
};

export const kissStyle = {
    fill: 'none',
    stroke: '#a31183',
    strokeWidth
};

export const creaselineStyle = {
    fill: 'none',
    stroke: '#00ff00',
    // stroke: 'blue',
    strokeWidth
};

export const safeZoneStyle = {
    fill: 'none',
    stroke: '#00AEEF',
    strokeDasharray: '.069,.069',
    strokeWidth
};
